<template>
    <div style="background: #eeeeee;" class="WhatsApp pl-1">
        <v-card>
            <v-dialog v-model="qrCodeDialog" width="500px">
                <v-img src="https://contabilidadelider.com/intranet/imgs/qrcode.png"></v-img>
            </v-dialog>
            <v-col color="orange" justify="center" class="mb-0 mt-0 pa-0">
                <v-tabs centered color="orange lighten-4" background-color="blue-grey darken-3" dark>
                    <v-tab>
                        <v-icon class="mr-2">mdi-whatsapp</v-icon>WhatsApp
                    </v-tab>
                    <v-tab>
                        <v-icon class="mr-2 ml-2">mdi-history</v-icon>Histórico
                    </v-tab>
                    <v-tab-item>
                        <v-row class="ma-0 pa-0">
                            <v-col cols="3">
                                <v-row class="mr-12 mb-0 mt-0 pa-0" justify="end">
                                    <v-col>
                                        <v-autocomplete dense v-model="model"
                                            :items="items[0].mensagens[0].body ? items : []" selected :clearable="true"
                                            item-text="senderName" item-value="_id" label="Procurar Conversa..."
                                            prepend-icon="mdi-comment-search-outline"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-btn @click="dialogNovaConversaM()" color="blue-grey lighten-3">
                                            <v-icon>mdi-message-plus-outline</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-card v-if="items[0].mensagens[0].body != ''" class="mx-auto">
                                    <vuescroll :ops="menuScroll">
                                        <v-list style="max-height: 613px;" three-line>
                                            <template v-for="(item, index) in items">
                                                <v-divider :key="item.chatId" v-if="index !== 0"></v-divider>
                                                <v-list-item :key="index" :style="background(item.seen)"
                                                    @click="clicouLista(index)">
                                                    <v-list-item-avatar>
                                                        <v-img v-if="item.avatarImg !== null" :src="item.avatarImg"
                                                            lazy-src="https://contabilidadelider.com/intranet/imgs/blank_profile.png"></v-img>
                                                    </v-list-item-avatar>

                                                    <v-list-item-content>
                                                        <v-list-item-title class="">
                                                            <!-- NomeAgenda é o elemento principal agora -->
                                                            <strong>{{ item.nomeAgenda }}</strong>
                                                            <!-- SenderName aparece ao lado com um tamanho de fonte menor -->
                                                            <span style="font-size: 0.75rem; margin-left: 8px;">{{
                                                                item.senderName }}</span>
                                                        </v-list-item-title>
                                                        <template v-if="items.length > 0">
                                                            <v-row>
                                                                <v-col>
                                                                    <v-list-item-subtitle class="caption">
                                                                        <template v-if="[
                                                                            'bmp',
                                                                            'jpg',
                                                                            'jpeg',
                                                                            'gif',
                                                                            'png',
                                                                            'eps',
                                                                            'raw',
                                                                            'apng',
                                                                            'ico',
                                                                            'svg',
                                                                            'jfif',
                                                                            'webp',
                                                                        ].some((el) =>
                                                                            RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                                .exec(
                                                                                    item.mensagens[
                                                                                        item.mensagens.length - 1
                                                                                    ].body
                                                                                )[0]
                                                                                .includes(el)
                                                                        )
                                                                        ">
                                                                            <v-icon>mdi-image</v-icon>
                                                                            <span>&nbsp;Imagem</span>
                                                                        </template>
                                                                        <template v-else-if="[
                                                                            'pdf',
                                                                            'csv',
                                                                            'zip',
                                                                            'rtf',
                                                                            '7zip',
                                                                            'rar',
                                                                            'txt',
                                                                            'doc',
                                                                            'docx',
                                                                            'xls',
                                                                            'xls',
                                                                            'xlsx',
                                                                            'ppt',
                                                                            'pptx',
                                                                            'ofx',
                                                                            'xml',
                                                                        ].some((el) =>
                                                                            RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                                .exec(
                                                                                    item.mensagens[
                                                                                        item.mensagens.length - 1
                                                                                    ].body
                                                                                )[0]
                                                                                .includes(el)
                                                                        )
                                                                        ">
                                                                            <v-icon>mdi-file</v-icon>
                                                                            <span>&nbsp;Arquivo</span>
                                                                        </template>
                                                                        <template v-else-if="['oga'].some((el) =>
                                                                            RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                                .exec(
                                                                                    item.mensagens[
                                                                                        item.mensagens.length - 1
                                                                                    ].body
                                                                                )[0]
                                                                                .includes(el)
                                                                        )
                                                                        ">
                                                                            <v-icon>mdi-microphone</v-icon>
                                                                            <span>&nbsp;Mensagem de Voz</span>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                style="word-break: break-word; max-width: 100%"
                                                                                v-html="item.mensagens[item.mensagens.length - 1]
                                                                                    .body
                                                                                    "></span>
                                                                        </template>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle class="overline mb-n5" v-html="' <strong>Setor: </strong> ' +
                                                                        item.setor[0] +
                                                                        '<strong> || ' +
                                                                        item.mensagens[item.mensagens.length - 1]
                                                                            .horarioBR +
                                                                        '</strong>'
                                                                        "></v-list-item-subtitle>
                                                                </v-col>
                                                                <v-icon v-show="!item.seen" style="display:inline"
                                                                    class="ml-n15" color="green">
                                                                    mdi-new-box</v-icon>
                                                            </v-row>
                                                        </template>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-list>
                                    </vuescroll>
                                </v-card>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <template v-if="indiceAtivo === -1">
                                <v-row
                                    style="  background-image:url('imgs/fnd.jpg');  background-color: hsla(0,0%,100%,0.70);
                                                                                                                                                                                                                                                                                                                                                                                                                                                    background-blend-mode: overlay;
                                                                                                                                                                                                                                                                                                                                                                                                                                                    background-repeat: no-repeat; background-repeat: repeat;height: 695px;margin-left: 0.02%">
                                    <v-container fill-height fluid>
                                        <v-row>
                                            <v-spacer></v-spacer>
                                            <v-col>
                                                <v-card class="pa-2" elevation="40">
                                                    <v-row>
                                                        <v-col>
                                                            <v-card-title
                                                                class="justify-center text-uppercase grey--text text--darken-3">WhatsApp
                                                            </v-card-title>
                                                            <v-card-title
                                                                class="justify-center text-uppercase grey--text text--darken-3">
                                                                <v-btn large @click="dialogNovaConversaM()" tile text
                                                                    min-height="100px">
                                                                    <v-icon class="justify-center" size="100"
                                                                        color="blue-grey lighten-2">
                                                                        mdi-android-messages</v-icon>
                                                                </v-btn>
                                                            </v-card-title>
                                                            <v-card-subtitle align="center" class="mt-3">Selecione ou
                                                                inicie
                                                                uma nova conversa.
                                                            </v-card-subtitle>
                                                            <v-card-subtitle align="center" class="justify-center">
                                                                Nosso
                                                                <strong>WhatsApp</strong>: (44) 35285291
                                                            </v-card-subtitle>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-col>
                                            <v-spacer></v-spacer>
                                        </v-row>
                                    </v-container>
                                </v-row>
                            </template>
                            <template v-else>
                                <v-col v-if="items[indiceAtivo].atendendo">
                                    <v-row class="mt-n3"
                                        style="background-image:url('imgs/fnd.jpg');  background-color: hsla(0,0%,100%,0.70);
                                                                                                                                                                                                                                                                                                                                                                                                                                                    background-blend-mode: overlay;
                                                                                                                                                                                                                                                                                                                                                                                                                                                    background-repeat: no-repeat; background-repeat: repeat;">
                                        <vuescroll ref="vs" :ops="ops">
                                            <v-list color="rgb(255, 0, 0, 0)" style=" width:100%;height: 615px;"
                                                class="d-flex align-start flex-column">
                                                <template v-for="(msg, index) in items[indiceAtivo].mensagens">
                                                    <v-container :key="index">
                                                        <v-row justify="end" v-if="msg.fromMe">
                                                            <v-card class="blue-grey lighten-3 pl-2 pr-2 mr-2 ml-2"
                                                                style="max-width: 60%; min-height:35px;min-width:60%;">
                                                                <!-- Imagem do colaborador
                                -->
                                                                <v-list-item-content v-if="[
                                                                    'bmp',
                                                                    'jpg',
                                                                    'jpeg',
                                                                    'gif',
                                                                    'png',
                                                                    'eps',
                                                                    'raw',
                                                                    'apng',
                                                                    'ico',
                                                                    'svg',
                                                                    'jfif',
                                                                    'webp',
                                                                ].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p class="body-2 ma-0">
                                                                            <strong>Uma imagem foi enviada:</strong>
                                                                        </p>
                                                                        <v-row>
                                                                            <v-col>
                                                                                <v-img :src="msg.body" height="150px"
                                                                                    width="150px"
                                                                                    style="cursor: pointer;"
                                                                                    @click="showImg(msg.body)">
                                                                                    <template v-slot:placeholder>
                                                                                        <v-row class="fill-height ma-0"
                                                                                            align="center"
                                                                                            justify="center">
                                                                                            <v-progress-circular
                                                                                                indeterminate
                                                                                                color="grey lighten-5">
                                                                                            </v-progress-circular>
                                                                                        </v-row>
                                                                                    </template>
                                                                                </v-img>
                                                                            </v-col>
                                                                            <v-divider inset vertical></v-divider>
                                                                            <v-col cols="7">
                                                                                <p class="caption pa-0"
                                                                                    style="word-break: break-word; max-width: 100%"
                                                                                    v-html="msg.caption"></p>
                                                                            </v-col>
                                                                            <vue-easy-lightbox moveDisabled
                                                                                :visible="visible" :imgs="imgs"
                                                                                :index="index"
                                                                                @hide="handleHide"></vue-easy-lightbox>
                                                                        </v-row>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1">
                                                                        <span align="end" class="overline ml-1 mr-1">
                                                                            <strong>{{ msg.horarioBR }}</strong>
                                                                        </span>
                                                                        <v-icon v-if="msg.ack === 2"
                                                                            size="medium">mdi-check-all</v-icon>
                                                                        <v-icon v-else-if="msg.ack == 3" size="medium"
                                                                            color="orange darken-4">mdi-check-all
                                                                        </v-icon>
                                                                        <v-icon v-else size="medium">mdi-check</v-icon>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <!-- arquivo do colaborador 
                      ['pdf?alt','txt?alt','doc?alt','docx?alt','xls?alt','xlsx?alt','ppt?alt','pptx?alt','xml?alt'].some(el=> msg.body.includes(el))
                      
                                -->

                                                                <v-list-item-content v-else-if="[
                                                                    'pdf',
                                                                    'csv',
                                                                    'zip',
                                                                    'rtf',
                                                                    '7zip',
                                                                    'rar',
                                                                    'txt',
                                                                    'doc',
                                                                    'docx',
                                                                    'xls',
                                                                    'xls',
                                                                    'xlsx',
                                                                    'ppt',
                                                                    'pptx',
                                                                    'ofx',
                                                                    'xml',
                                                                ].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p>
                                                                            <strong>Um Documento foi enviado:</strong>
                                                                        </p>
                                                                        <v-btn outlined rounded target="_blank"
                                                                            :href="msg.body">
                                                                            <v-icon left>mdi-file</v-icon>
                                                                            <Strong>ABRIR DOCUMENTO</Strong>
                                                                        </v-btn>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1">
                                                                        <span align="end" class="overline ml-1 mr-1">
                                                                            <strong>{{ msg.horarioBR }}</strong>
                                                                        </span>
                                                                        <v-icon v-if="msg.ack === 2"
                                                                            size="medium">mdi-check-all</v-icon>
                                                                        <v-icon v-else-if="msg.ack == 3" size="medium"
                                                                            color="orange darken-4">mdi-check-all
                                                                        </v-icon>
                                                                        <v-icon v-else size="medium">mdi-check</v-icon>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>

                                                                <v-list-item-content
                                                                    v-else-if="msg.body.includes('.oga?alt')"
                                                                    class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p class="pb-2">
                                                                            <strong>Uma mensagem de voz foi
                                                                                enviada:</strong>
                                                                        </p>
                                                                        <vuetify-audio :file="msg.body"></vuetify-audio>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1">
                                                                        <span align="end" class="overline ml-1 mr-1">
                                                                            <strong>{{ msg.horarioBR }}</strong>
                                                                        </span>
                                                                        <v-icon v-if="msg.ack === 2"
                                                                            size="medium">mdi-check-all</v-icon>
                                                                        <v-icon v-else-if="msg.ack == 3" size="medium"
                                                                            color="orange darken-4">mdi-check-all
                                                                        </v-icon>
                                                                        <v-icon v-else size="medium">mdi-check</v-icon>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>

                                                                <v-list-item-content v-else class="body-2">
                                                                    <p class="caption pa-0"
                                                                        style="word-break: break-word; max-width: 100%"
                                                                        v-html="msg.body"></p>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1">
                                                                        <span align="end" class="overline ml-1 mr-1">
                                                                            <strong>{{ msg.horarioBR }}</strong>
                                                                        </span>
                                                                        <v-icon v-if="msg.ack === 2"
                                                                            size="medium">mdi-check-all</v-icon>
                                                                        <v-icon v-else-if="msg.ack == 3" size="medium"
                                                                            color="orange darken-4">mdi-check-all
                                                                        </v-icon>
                                                                        <v-icon v-else size="medium">mdi-check</v-icon>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </v-card>
                                                        </v-row>
                                                        <v-row v-else>
                                                            <v-card class="white pl-2 pr-2 mr-2 ml-2"
                                                                style="max-width: 60%; min-height:35px;min-width:60%;">
                                                                <v-list-item-content v-if="[
                                                                    'bmp',
                                                                    'jpg',
                                                                    'jpeg',
                                                                    'gif',
                                                                    'png',
                                                                    'eps',
                                                                    'raw',
                                                                    'apng',
                                                                    'ico',
                                                                    'svg',
                                                                    'jfif',
                                                                    'webp',
                                                                ].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p class="body-2 ma-0">
                                                                            <strong>Uma imagem foi enviada:</strong>
                                                                        </p>
                                                                        <v-row>
                                                                            <v-col>
                                                                                <v-img :src="msg.body" height="150px"
                                                                                    width="150px"
                                                                                    style="cursor: pointer;"
                                                                                    @click="showImg(msg.body)">
                                                                                    <template v-slot:placeholder>
                                                                                        <v-row class="fill-height ma-0"
                                                                                            align="center"
                                                                                            justify="center">
                                                                                            <v-progress-circular
                                                                                                indeterminate
                                                                                                color="grey lighten-5">
                                                                                            </v-progress-circular>
                                                                                        </v-row>
                                                                                    </template>
                                                                                </v-img>
                                                                            </v-col>
                                                                            <vue-easy-lightbox moveDisabled
                                                                                :visible="visible" :imgs="imgs"
                                                                                :index="index"
                                                                                @hide="handleHide"></vue-easy-lightbox>
                                                                            <v-divider inset vertical></v-divider>
                                                                            <v-col cols="7">
                                                                                <p class="caption pa-0"
                                                                                    style="word-break: break-word;; max-width: 100%"
                                                                                    v-html="msg.caption">
                                                                                </p>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1"
                                                                        v-html="'<strong>' + msg.horarioBR + '</strong>'"></v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <v-list-item-content v-else-if="[
                                                                    'pdf',
                                                                    'csv',
                                                                    'zip',
                                                                    'rtf',
                                                                    '7zip',
                                                                    'rar',
                                                                    'txt',
                                                                    'doc',
                                                                    'docx',
                                                                    'xls',
                                                                    'xls',
                                                                    'xlsx',
                                                                    'ppt',
                                                                    'pptx',
                                                                    'ofx',
                                                                    'xml',
                                                                ].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p>
                                                                            <strong>Um Documento foi enviado:</strong>
                                                                        </p>
                                                                        <v-btn outlined rounded target="_blank"
                                                                            :href="msg.body">
                                                                            <v-icon left>mdi-file</v-icon>
                                                                            <Strong>ABRIR DOCUMENTO</Strong>
                                                                        </v-btn>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1"
                                                                        v-html="'<strong>' + msg.horarioBR + '</strong>'"></v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <v-list-item-content v-else-if="['oga'].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p class="pb-2">
                                                                            <strong>Uma mensagem de voz foi
                                                                                enviada:</strong>
                                                                        </p>
                                                                        <vuetify-audio
                                                                            style="max-width: 200px;max-height: 120px"
                                                                            :file="msg.body">
                                                                        </vuetify-audio>
                                                                        <v-list-item-subtitle align="end"
                                                                            class="overline ml-1 mr-1">
                                                                            <v-btn small class="orange lighten-4"
                                                                                @click="copiarAudio()">Copiar
                                                                                Audio</v-btn>
                                                                            <input type="hidden" id="audioBody"
                                                                                :value="msg.body" />
                                                                        </v-list-item-subtitle>
                                                                    </v-list-item-subtitle>

                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1"
                                                                        v-html="'<strong>' + msg.horarioBR + '</strong>'"></v-list-item-subtitle>
                                                                </v-list-item-content>

                                                                <v-list-item-content v-else class="body-2">
                                                                    <v-card v-if="msg.quotedMsgBody !== null"
                                                                        color="grey lighten-2"
                                                                        style="max-width: 65%; margin-right: 40%; min-height: 35px;word-break: break-word;;">
                                                                        <p class="caption pa-1"
                                                                            style="word-break: break-word;; max-width: 100%"
                                                                            v-html="msg.quotedMsgBody"></p>
                                                                    </v-card>
                                                                    <p class="caption pa-0"
                                                                        style="word-break: break-word;; max-width: 100%"
                                                                        v-html="msg.body"></p>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1"
                                                                        v-html="'<strong>' + msg.horarioBR + '</strong>'"></v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </v-card>
                                                        </v-row>
                                                    </v-container>
                                                </template>
                                            </v-list>
                                        </vuescroll>
                                    </v-row>

                                    <v-form dense v-model="valid" @submit.prevent id="formMensagem">
                                        <v-row dense class="mt-1">
                                            <v-col dense cols="10">
                                                <div class="wrapper">
                                                    <v-lazy>
                                                        <v-textarea rows="2" auto-grow outlined label="Mensagem"
                                                            prepend-icon="mdi-message" dense required
                                                            :disabled="disabledMensagem" :autofocus="true"
                                                            form="formMensagem" ref="mensagem" @focus="limparCampo()"
                                                            :rules="msgRules" :value="mensagem"
                                                            @change.native="mensagem = $event.target.value"
                                                            v-on:keydown.enter="(mensagem = $event.target.value), enviarMsg()"></v-textarea>
                                                    </v-lazy>

                                                    <emoji-picker @emoji="append" :search="search">
                                                        <div class="emoji-invoker" slot="emoji-invoker"
                                                            slot-scope="{ events: { click: clickEvent } }"
                                                            @click.stop="clickEvent">
                                                            <svg height="28" viewBox="0 0 25 25" width="30"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M0 0h24v24H0z" fill="none" />
                                                                <path
                                                                    d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
                                                            </svg>
                                                        </div>
                                                        <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                                                            <div class="emoji-picker"
                                                                :style="{ top: -340 + 'px', left: 93.2 + '%' }">
                                                                <vuescroll :ops="menuScroll">
                                                                    <div>
                                                                        <div v-for="(emojiGroup, category) in emojis"
                                                                            :key="category">
                                                                            <h5>
                                                                                {{
                                                                                    category == "Frequently used"
                                                                                        ? (category = "Mais Usados")
                                                                                        : category == "People"
                                                                                            ? (category = "Pessoas")
                                                                                            : category == "Nature"
                                                                                                ? (category = "Natureza")
                                                                                                : category == "Objects"
                                                                                                    ? (category = "Objetos")
                                                                                                    : category == "Places"
                                                                                                        ? (category = "Lugares")
                                                                                                        : category == "Symbols"
                                                                                                            ? (category = "Simbolos")
                                                                                                            : ""
                                                                                }}
                                                                            </h5>
                                                                            <div class="emojis">
                                                                                <span
                                                                                    v-for="(emoji, emojiName) in emojiGroup"
                                                                                    :key="emojiName"
                                                                                    @click="insert(emoji)"
                                                                                    :title="emojiName">{{ emoji
                                                                                    }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </vuescroll>
                                                            </div>
                                                        </div>
                                                    </emoji-picker>
                                                </div>
                                                <v-alert class="caption ma-0 pa-0" align="center" justify="center">
                                                    Você também pode formatar suas mensagem da seguinte maneira:
                                                    <strong>*negrito</strong>* _
                                                    <i>itálico</i>_ ```
                                                    <span style="font-family: monospace">monospace</span>```
                                                </v-alert>
                                            </v-col>
                                            <v-col align="end" cols="1">
                                                <v-btn fab dark small class="mr-2 mt-3" color="blue-grey darken-3"
                                                    @click="
                                                        dialogFileUpload = true;
                                                    txtFileInput = [];
                                                    caption = '';

                                                    ">
                                                    <v-icon dark>mdi-paperclip</v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col align="end" cols="1">
                                                <v-btn :loading="loading" fab dark small color="blue-grey darken-3"
                                                    class="mt-3">
                                                    <v-icon :loading="loading" :disabled="!valid" type="submit"
                                                        form="formMensagem" @click="(loader = 'loading'), enviarMsg()"
                                                        dark>mdi-send</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="2">
                                    <v-card v-if="items[indiceAtivo].atendendo">
                                        <v-img v-if="items[indiceAtivo].avatarImg !== null"
                                            :src="items[indiceAtivo].avatarImg"
                                            lazy-src="https://contabilidadelider.com/intranet/imgs/blank_profile.png"
                                            height="280px" dark>
                                        </v-img>
                                        <v-list two-line class="pt-0">
                                            <v-list-item class="blue-grey darken-3">
                                                <v-list-item-content>
                                                    <v-row>
                                                        <v-col></v-col>
                                                        <v-col>
                                                            <v-list-item-title class="orange--text text--lighten-4">
                                                                <!-- Mostra o nomeAgenda se indiceAtivo não for -1, caso contrário, não mostra nada -->
                                                                <div v-if="indiceAtivo != -1">
                                                                    <strong>{{ items[indiceAtivo].nomeAgenda }}</strong>
                                                                    <div v-show="items[indiceAtivo].senderName"
                                                                        style="font-size: 0.75rem; margin-top: 4px;">
                                                                        {{ items[indiceAtivo].senderName }}
                                                                    </div>
                                                                </div>
                                                                <div v-else>
                                                                    <!-- Quando indiceAtivo é -1, você pode optar por exibir alguma outra informação ou deixar vazio -->
                                                                </div>
                                                            </v-list-item-title>
                                                        </v-col>
                                                        <v-col></v-col>
                                                    </v-row>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon color="orange lighten-2 ">mdi-phone</v-icon>
                                                </v-list-item-icon>

                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        v-text="items[indiceAtivo].tel"></v-list-item-title>
                                                    <v-list-item-subtitle>Telefone</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-divider inset></v-divider>

                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon color="orange lighten-2">mdi-email</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        v-text="items[indiceAtivo].email"></v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-divider inset></v-divider>

                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon color="orange lighten-2">mdi-message-text</v-icon>
                                                </v-list-item-icon>

                                                <v-list-item-content>
                                                    <v-list-item-title>Informações Adicionais</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-row justify="center">
                                                    <v-btn small class="orange lighten-4" @click="
                                                        vsetor = items[indiceAtivo].setor[0];
                                                    dialogSetor = true;">Transferir
                                                        de
                                                        Setor</v-btn>
                                                </v-row>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-row justify="center">
                                                    <v-btn small class="success"
                                                        @click="dialogFinalizarAtendimento = true">Concluir Atendimento
                                                    </v-btn>
                                                </v-row>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>
                            </template>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item>
                        <v-row class="ma-0 pa-0">
                            <v-col cols="3">
                                <v-row class="mb-0 mt-0 pa-0" justify="end">
                                    <v-col>
                                        <v-autocomplete dense v-model="modelHist" item-value="chatId"
                                            :items="histConversas" selected :clearable="true" item-text="nomeAgenda"
                                            @focus="atualizarContatos" label="Procurar Conversa..."
                                            prepend-icon="mdi-comment-search-outline">
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <template v-if="indiceAtivoHist === -1">
                                <v-row
                                    style="  background-image:url('imgs/fnd.jpg');  background-color: hsla(0,0%,100%,0.70);
                                                                                                                                                                                                                                                                                                                                                                                                                                                    background-blend-mode: overlay;
                                                                                                                                                                                                                                                                                                                                                                                                                                                    background-repeat: no-repeat; background-repeat: repeat;height: 695px;margin-left: 0.02%">
                                    <v-container fill-height fluid>
                                        <v-row>
                                            <v-spacer></v-spacer>
                                            <v-col>
                                                <v-card class="pa-2" elevation="40">
                                                    <v-row>
                                                        <v-col>
                                                            <v-card-title
                                                                class="justify-center text-uppercase grey--text text--darken-3">Histórico
                                                                de
                                                                Mensagens</v-card-title>

                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-col>
                                            <v-spacer></v-spacer>
                                        </v-row>
                                    </v-container>
                                </v-row>
                            </template>
                            <template v-else>
                                <v-col>
                                    <v-row class="mt-n3"
                                        style="background-image:url('imgs/fnd.jpg');  background-color: hsla(0,0%,100%,0.70);
                                                                                                                                                                                                                                                                                                                                                                                                                                                    background-blend-mode: overlay;
                                                                                                                                                                                                                                                                                                                                                                                                                                                    background-repeat: no-repeat; background-repeat: repeat;">
                                        <vuescroll ref="vs" :ops="ops">
                                            <v-list color="rgb(255, 0, 0, 0)" style=" width:100%;height: 695px;"
                                                class="d-flex align-start flex-column">
                                                <template
                                                    v-for="(msg, indexHist) in itemsHist[indiceAtivoHist].mensagens">
                                                    <v-container :key="indexHist">
                                                        <v-row justify="end" v-if="msg.fromMe">
                                                            <v-card class="blue-grey lighten-3 pl-2 pr-2 mr-2 ml-2"
                                                                style="max-width: 60%; min-height:35px;min-width:60%;">
                                                                <!-- Imagem do colaborador
                                -->
                                                                <v-list-item-content v-if="[
                                                                    'bmp',
                                                                    'jpg',
                                                                    'jpeg',
                                                                    'gif',
                                                                    'png',
                                                                    'eps',
                                                                    'raw',
                                                                    'apng',
                                                                    'ico',
                                                                    'svg',
                                                                    'jfif',
                                                                    'webp',
                                                                ].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p class="body-2 ma-0">
                                                                            <strong>Uma imagem foi enviada:</strong>
                                                                        </p>
                                                                        <v-row>
                                                                            <v-col>
                                                                                <v-img :src="msg.body" height="150px"
                                                                                    width="150px"
                                                                                    style="cursor: pointer;"
                                                                                    @click="showImg(msg.body)">
                                                                                    <template v-slot:placeholder>
                                                                                        <v-row class="fill-height ma-0"
                                                                                            align="center"
                                                                                            justify="center">
                                                                                            <v-progress-circular
                                                                                                indeterminate
                                                                                                color="grey lighten-5">
                                                                                            </v-progress-circular>
                                                                                        </v-row>
                                                                                    </template>
                                                                                </v-img>
                                                                            </v-col>
                                                                            <v-divider inset vertical></v-divider>
                                                                            <v-col cols="7">
                                                                                <p class="caption pa-0"
                                                                                    style="word-break: break-word; max-width: 100%"
                                                                                    v-html="msg.caption"></p>
                                                                            </v-col>
                                                                            <vue-easy-lightbox moveDisabled
                                                                                :visible="visible" :imgs="imgs"
                                                                                :index="indexHist"
                                                                                @hide="handleHide"></vue-easy-lightbox>
                                                                        </v-row>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1">
                                                                        <span align="end" class="overline ml-1 mr-1">
                                                                            <strong>{{ msg.horarioBR }}</strong>
                                                                        </span>
                                                                        <v-icon v-if="msg.ack === 2"
                                                                            size="medium">mdi-check-all</v-icon>
                                                                        <v-icon v-else-if="msg.ack == 3" size="medium"
                                                                            color="orange darken-4">mdi-check-all
                                                                        </v-icon>
                                                                        <v-icon v-else size="medium">mdi-check</v-icon>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <!-- arquivo do colaborador 
                      ['pdf?alt','txt?alt','doc?alt','docx?alt','xls?alt','xlsx?alt','ppt?alt','pptx?alt','xml?alt'].some(el=> msg.body.includes(el))
                      
                                -->

                                                                <v-list-item-content v-else-if="[
                                                                    'pdf',
                                                                    'csv',
                                                                    'zip',
                                                                    'rtf',
                                                                    '7zip',
                                                                    'rar',
                                                                    'txt',
                                                                    'doc',
                                                                    'docx',
                                                                    'xls',
                                                                    'xls',
                                                                    'xlsx',
                                                                    'ppt',
                                                                    'pptx',
                                                                    'ofx',
                                                                    'xml',
                                                                ].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p>
                                                                            <strong>Um Documento foi enviado:</strong>
                                                                        </p>
                                                                        <v-btn outlined rounded target="_blank"
                                                                            :href="msg.body">
                                                                            <v-icon left>mdi-file</v-icon>
                                                                            <Strong>ABRIR DOCUMENTO</Strong>
                                                                        </v-btn>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1">
                                                                        <span align="end" class="overline ml-1 mr-1">
                                                                            <strong>{{ msg.horarioBR }}</strong>
                                                                        </span>
                                                                        <v-icon v-if="msg.ack === 2"
                                                                            size="medium">mdi-check-all</v-icon>
                                                                        <v-icon v-else-if="msg.ack == 3" size="medium"
                                                                            color="orange darken-4">mdi-check-all
                                                                        </v-icon>
                                                                        <v-icon v-else size="medium">mdi-check</v-icon>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>

                                                                <v-list-item-content
                                                                    v-else-if="msg.body.includes('.oga?alt')"
                                                                    class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p class="pb-2">
                                                                            <strong>Uma mensagem de voz foi
                                                                                enviada:</strong>
                                                                        </p>
                                                                        <vuetify-audio :file="msg.body"></vuetify-audio>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1">
                                                                        <span align="end" class="overline ml-1 mr-1">
                                                                            <strong>{{ msg.horarioBR }}</strong>
                                                                        </span>
                                                                        <v-icon v-if="msg.ack === 2"
                                                                            size="medium">mdi-check-all</v-icon>
                                                                        <v-icon v-else-if="msg.ack == 3" size="medium"
                                                                            color="orange darken-4">mdi-check-all
                                                                        </v-icon>
                                                                        <v-icon v-else size="medium">mdi-check</v-icon>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>

                                                                <v-list-item-content v-else class="body-2">
                                                                    <p class="caption pa-0"
                                                                        style="word-break: break-word; max-width: 100%"
                                                                        v-html="msg.body"></p>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1">
                                                                        <span align="end" class="overline ml-1 mr-1">
                                                                            <strong>{{ msg.horarioBR }}</strong>
                                                                        </span>
                                                                        <v-icon v-if="msg.ack === 2"
                                                                            size="medium">mdi-check-all</v-icon>
                                                                        <v-icon v-else-if="msg.ack == 3" size="medium"
                                                                            color="orange darken-4">mdi-check-all
                                                                        </v-icon>
                                                                        <v-icon v-else size="medium">mdi-check</v-icon>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </v-card>
                                                        </v-row>
                                                        <v-row v-else>
                                                            <v-card class="white pl-2 pr-2 mr-2 ml-2"
                                                                style="max-width: 60%; min-height:35px;min-width:60%;">
                                                                <v-list-item-content v-if="[
                                                                    'bmp',
                                                                    'jpg',
                                                                    'jpeg',
                                                                    'gif',
                                                                    'png',
                                                                    'eps',
                                                                    'raw',
                                                                    'apng',
                                                                    'ico',
                                                                    'svg',
                                                                    'jfif',
                                                                    'webp',
                                                                ].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p class="body-2 ma-0">
                                                                            <strong>Uma imagem foi enviada:</strong>
                                                                        </p>
                                                                        <v-row>
                                                                            <v-col>
                                                                                <v-img :src="msg.body" height="150px"
                                                                                    width="150px"
                                                                                    style="cursor: pointer;"
                                                                                    @click="showImg(msg.body)">
                                                                                    <template v-slot:placeholder>
                                                                                        <v-row class="fill-height ma-0"
                                                                                            align="center"
                                                                                            justify="center">
                                                                                            <v-progress-circular
                                                                                                indeterminate
                                                                                                color="grey lighten-5">
                                                                                            </v-progress-circular>
                                                                                        </v-row>
                                                                                    </template>
                                                                                </v-img>
                                                                            </v-col>
                                                                            <vue-easy-lightbox moveDisabled
                                                                                :visible="visible" :imgs="imgs"
                                                                                :index="indexHist"
                                                                                @hide="handleHide"></vue-easy-lightbox>
                                                                            <v-divider inset vertical></v-divider>
                                                                            <v-col cols="7">
                                                                                <p class="caption pa-0"
                                                                                    style="word-break: break-word;; max-width: 100%"
                                                                                    v-html="msg.caption"></p>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1"
                                                                        v-html="'<strong>' + msg.horarioBR + '</strong>'"></v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <v-list-item-content v-else-if="[
                                                                    'pdf',
                                                                    'csv',
                                                                    'zip',
                                                                    'rtf',
                                                                    '7zip',
                                                                    'rar',
                                                                    'txt',
                                                                    'doc',
                                                                    'docx',
                                                                    'xls',
                                                                    'xls',
                                                                    'xlsx',
                                                                    'ppt',
                                                                    'pptx',
                                                                    'ofx',
                                                                    'xml',
                                                                ].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p>
                                                                            <strong>Um Documento foi enviado:</strong>
                                                                        </p>
                                                                        <v-btn outlined rounded target="_blank"
                                                                            :href="msg.body">
                                                                            <v-icon left>mdi-file</v-icon>
                                                                            <Strong>ABRIR DOCUMENTO</Strong>
                                                                        </v-btn>
                                                                    </v-list-item-subtitle>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1"
                                                                        v-html="'<strong>' + msg.horarioBR + '</strong>'"></v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <v-list-item-content v-else-if="['oga'].some((el) =>
                                                                    RegExp(/\.[0-9a-z]{1,5}$|$/)
                                                                        .exec(msg.body)[0]
                                                                        .includes(el)
                                                                )
                                                                " class="body-2">
                                                                    <v-list-item-subtitle>
                                                                        <p class="pb-2">
                                                                            <strong>Uma mensagem de voz foi
                                                                                enviada:</strong>
                                                                        </p>
                                                                        <vuetify-audio
                                                                            style="max-width: 200px;max-height: 120px"
                                                                            :file="msg.body">
                                                                        </vuetify-audio>
                                                                        <v-list-item-subtitle align="end"
                                                                            class="overline ml-1 mr-1">
                                                                            <v-btn small class="orange lighten-4"
                                                                                @click="copiarAudio()">Copiar
                                                                                Audio</v-btn>
                                                                            <input type="hidden" id="audioBody"
                                                                                :value="msg.body" />
                                                                        </v-list-item-subtitle>
                                                                    </v-list-item-subtitle>

                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1"
                                                                        v-html="'<strong>' + msg.horarioBR + '</strong>'"></v-list-item-subtitle>
                                                                </v-list-item-content>

                                                                <v-list-item-content v-else class="body-2">
                                                                    <v-card v-if="msg.quotedMsgBody !== null"
                                                                        color="grey lighten-2"
                                                                        style="max-width: 65%; margin-right: 40%; min-height: 35px;word-break: break-word;;">
                                                                        <p class="caption pa-1"
                                                                            style="word-break: break-word;; max-width: 100%"
                                                                            v-html="msg.quotedMsgBody">
                                                                        </p>
                                                                    </v-card>
                                                                    <p class="caption pa-0"
                                                                        style="word-break: break-word;; max-width: 100%"
                                                                        v-html="msg.body"></p>
                                                                    <v-list-item-subtitle align="end"
                                                                        class="overline ml-1 mr-1"
                                                                        v-html="'<strong>' + msg.horarioBR + '</strong>'"></v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </v-card>
                                                        </v-row>
                                                    </v-container>
                                                </template>
                                            </v-list>
                                        </vuescroll>
                                    </v-row>
                                </v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="2">
                                    <v-card>
                                        <v-img v-if="itemsHist[indiceAtivoHist].avatarImg !== null"
                                            :src="itemsHist[indiceAtivoHist].avatarImg"
                                            lazy-src="https://contabilidadelider.com/intranet/imgs/blank_profile.png"
                                            height="280px" dark>
                                        </v-img>
                                        <v-list two-line class="pt-0">
                                            <v-list-item class="blue-grey darken-3">
                                                <v-list-item-content>
                                                    <v-row>
                                                        <v-col></v-col>
                                                        <v-col>
                                                            <v-list-item-title class="orange--text text--lighten-4"
                                                                v-text="indiceAtivoHist != -1
                                                                    ? itemsHist[indiceAtivoHist].senderName
                                                                    : ''
                                                                    "></v-list-item-title>
                                                        </v-col>
                                                        <v-col></v-col>
                                                    </v-row>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon color="orange lighten-2 ">mdi-phone</v-icon>
                                                </v-list-item-icon>

                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        v-text="itemsHist[indiceAtivoHist].tel"></v-list-item-title>
                                                    <v-list-item-subtitle>Telefone</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-divider inset></v-divider>

                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon color="orange lighten-2">mdi-email</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>email@email</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-divider inset></v-divider>

                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon color="orange lighten-2">mdi-message-text</v-icon>
                                                </v-list-item-icon>

                                                <v-list-item-content>
                                                    <v-list-item-title>Informações Adicionais</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>
                            </template>
                        </v-row>
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-card>
        <v-dialog v-model="dialogFileUpload" persistent max-width="400">
            <v-card>
                <v-alert type="info" class="text-center" dense>
                    <strong>Enviar ARQUIVOS</strong>
                </v-alert>
                <p class="body-2 text-center">
                    <Strong>Os tipos de Arquivos aceitos são:</Strong>
                    <i>Imagens e Documentos</i>
                    <br />
                    <br />Você pode enviar
                    <strong>imagens e arquivos</strong> de até
                    <strong>15 MB</strong>
                    <br />
                    <br />
                    <strong>Envie ao maximo 5 arquivos por ação.</strong>
                    <v-form v-model="zad" id="formUpload" @submit.prevent>
                        <div id="pastediv" ref="pastediv" @paste="paste">
                            <v-file-input :clearable="true" required :rules="fileRules"
                                accept="image/*, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.slideshow, application/vnd.openxmlformats-officedocument.presentationml.presentation, .pdf, .xls, .xlsx, .txt, .rtf, .xml, .ofx"
                                style="max-width: 300px" class="ml-12 mb-3 mt-3" outlined v-model="txtFileInput" dense
                                small-chips show-size multiple form="formUpload" label="Arquivos"></v-file-input>
                            <v-text-field prepend-icon="mdi-closed-caption-outline" :clearable="true"
                                style="max-width: 300px" class="ml-12 mb-3 mt-3" outlined v-model="caption" dense
                                form="formUpload" label="Adicionar uma Legenda"></v-text-field>
                            <v-btn color="green darken-1" text form="formUpload" type="submit" :disabled="!validUpload"
                                :loading="loadingUpload"
                                @click="(loaderUpload = 'loadingUpload'), enviarArquivos()">Enviar
                                Arquivos
                            </v-btn>
                            <v-btn color="red darken-1" text @click="
                                dialogFileUpload = false;
                            txtFileInput = [];">CANCELAR
                                OPERAÇÃO</v-btn>
                        </div>
                    </v-form>
                </p>
                <br />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogFinalizarAtendimento" persistent max-width="400">
            <v-card>
                <v-alert type="info" class="text-center" dense>
                    <strong>FINALIZAR ATENDIMENTO</strong>
                </v-alert>
                <p class="body-2 text-center">
                    Você gostaria de
                    <strong>FINALIZAR</strong> o atendimento para
                    <strong>{{ indiceAtivo != -1 ? items[indiceAtivo].senderName : "" }}</strong>
                    ?
                    <br />
                    <br />
                    <strong>Ele será notificado do fim do atendimento</strong>
                    <v-btn color="green darken-1" text @click="
                        dialogFinalizarAtendimento = false;
                    concluirAtendimento();">FINALIZAR
                        ATENDIMENTO</v-btn>
                    <v-btn color="red darken-1" text @click="dialogFinalizarAtendimento = false">NÃO FINALIZAR</v-btn>
                </p>
                <br />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogNovaConversa" max-width="500">
            <v-card>
                <v-alert type="info" class="text-center" dense>
                    <strong>INICIAR NOVA CONVERSA</strong>
                </v-alert>
                <p class="body-2 text-center">
                    Escolha ou insira o numero de telefone para iniciar uma nova conversa.
                    <br />
                    <br />
                    <strong>O atendimento para este numero iniciará automaticamente.</strong>
                    <br />
                    <br />
                    <!-- <v-alert
            dismissible
            v-model="notificationAlert"
            color="red"
            dark
            dense
            icon="mdi-chat-alert"
            prominent
            class="ma-2 mb-10"
          >
           <p class="body-2 text-justify">
              Para que o nosso numero não seja bloqueado pelo
              <strong>WhatsApp</strong> não envie mensagem para numeros que não
              autorizam (ex: Pessoas que não conhecem o nosso escritório,
              marketing) receber mensagens do Escritório Líder.
            </p>
            <p>
              Para
              <strong>MENSAGENS EM MASSA</strong> temos um limite de 10 contatos
              a cada
              <strong>10 MINUTOS</strong> assim evitamos ser bloqueados.
            </p>
            <p class="h1">
              <i>RESPEITE O LIMITE DE TEMPO</i>
            </p>
          </v-alert>!-->
                    <v-form v-model="validAc" @submit.prevent id="formMensagemAc">
                        <v-autocomplete dense chips :multiple="false" v-model="telefonesAc" :items="telefones" clearable
                            class="ma-3" required return-object form="formMensagemAc" label="Procurar Contato"
                            item-text="nome" item-value="chatId" :rules="telefonesAcRules"
                            prepend-icon="mdi-comment-search-outline" ref="autocomplete">
                            <template v-slot:item="{ item }">
                                <v-list-item @click="telefoneClicado(item)">
                                    <v-list-item-content class="body-2" v-html="item.nome + ' <strong>' + item.celular + '</strong>'
                                        "></v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-autocomplete>

                        <v-textarea rows="2" auto-grow outlined label="Mensagem" value prepend-icon="mdi-message" dense
                            v-model="mensagemAc" required form="formMensagem" ref="mensagem" class="ma-3"
                            :rules="msgRules">
                        </v-textarea>

                        <v-btn color="green darken-1" text :disabled="!validAc" type="submit" @click="
                            dialogNovaConversa = false;
                        iniciarNovaConversa();
                        mensagemAc = '';
                        telefonesAc = '';
                        ">INICIAR
                            NOVA
                            CONVERSA</v-btn>
                        <v-btn color="red darken-1" text @click="
                            dialogNovaConversa = false;
                        mensagemAc = '';
                        telefonesAc = '';
                        ">NÃO
                            INICIAR</v-btn>
                    </v-form>
                </p>
                <br />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAtendimento" persistent max-width="400">
            <v-card>
                <v-alert type="info" class="text-center" dense>
                    <strong>INICIAR ATENDIMENTO</strong>
                </v-alert>
                <p class="body-2 text-center">
                    Você gostaria de iniciar o atendimento para
                    <strong>{{ indiceAtivo != -1 ? items[indiceAtivo].senderName : "" }}</strong>
                    ?
                    <br />
                    <strong>Ele será notificado do inicio do atendimento</strong>
                    <v-btn color="green darken-1" text @click="
                        dialogAtendimento = false;
                    iniciarAtendimento();
                    ">INICIAR
                        ATENDIMENTO</v-btn>
                    <v-btn color="red darken-1" text @click="dialogAtendimento = false">NÃO INICIAR</v-btn>
                </p>
                <br />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSetor" persistent max-width="400">
            <v-card>
                <v-alert type="info" class="text-center" dense>
                    <strong>TRANSFERÊNCIA DE SETOR</strong>
                </v-alert>
                <p class="body-2 text-center">
                    Você gostaria para transferir para qual setor ?
                    <v-select outlined v-model="vsetor" :items="setores" menu-props="auto" hide-details dense
                        style="max-width: 300px" class="ml-12 mb-3 mt-3"></v-select>
                    <v-btn color="green darken-1" text @click="
                        dialogSetor = false;
                    mudarSetor();
                    ">TRANSFERIR</v-btn>
                    <v-btn color="red darken-1" text @click="dialogSetor = false">CANCELAR TRANSFERÊNCIA</v-btn>
                </p>
                <br />
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogError" max-width="400">
            <v-card>
                <v-alert type="error" v-html="this.msgErro"></v-alert>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEditarContato" scrollable min-width="50%" max-width="800px">
            <v-card height="600px">
                <v-alert type="info" class="text-center" dense>
                    <strong>ATUALIZANDO INFORMAÇÕES DO CONTATO</strong>
                </v-alert>
                <p class="body-2 text-center ma-4">
                    Modificando os dados de
                    <strong>{{ col.nome }}</strong>
                </p>
                <v-divider></v-divider>
                <vuescroll ref="vs" :ops="ops">
                    <v-form class="mt-1 mx-3" v-model="valid" @submit.prevent>
                        <v-text-field :outlined="true" label="Nome Completo" hint="Exemplo: Victor Barbieri"
                            prepend-icon="mdi-account" required autofocus dense :rules="nomeRules"
                            v-model="nome"></v-text-field>

                        <v-text-field :outlined="true" label="Telefone Fixo" value prepend-icon="mdi-phone" dense
                            v-model="telefone" hint="Insira somente numeros" :rules="telefoneRules"></v-text-field>
                        <v-text-field :outlined="true" label="Telefone Celular / WhatsApp" value
                            prepend-icon="mdi-cellphone" dense v-model="celular" :rules="celularRules"
                            hint="Insira somente numeros sem o numero 9 adicional">
                        </v-text-field>
                        <v-text-field :outlined="true" label="E-mail" prepend-icon="mdi-card-account-mail"
                            :rules="emailRules" v-model="email" dense></v-text-field>
                        <v-textarea dense prepend-icon="mdi-comment" clearable :outlined="true" rows="4"
                            v-model="complementares" label="Informações Complementares" value></v-textarea>
                    </v-form>
                </vuescroll>
                <v-divider></v-divider>
                <p class="text-center">
                    <v-btn color="green darken-1" text :disabled="!valid" :loading="loading" @click="(loader = 'loading');
                    dialogEditarContato = false
                    editarContatoBD();

                    ">MODIFICAR</v-btn>
                    <v-btn color="red darken-1" text @click="dialogEditarContato = false">CANCELAR EDIÇÃO</v-btn>
                </p>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import io from "socket.io-client";
import EmojiPicker from "vue-emoji-picker";
import vuescroll from "vuescroll/dist/vuescroll-native";
export default {
    components: {
        VuetifyAudio: () => import("vuetify-audio"),
        VueEasyLightbox: () => import("vue-easy-lightbox"),
        vuescroll,
        EmojiPicker,
    },
    name: "WhatsApp",
    data() {
        return {
            input: "",
            search: "",
            error: "",
            timrId: null,
            msgErro: "",
            nome: "",
            celular: "",
            complementares: "",
            email: "",
            telefone: "",
            atualizado: "",
            dialogError: false,
            menuScroll: {
                vuescroll: {
                    detectResize: false,
                },
                scrollPanel: {
                    initialScrollY: 0,
                },

                bar: {
                    showDelay: 500,
                    onlyShowBarOnScroll: true,
                    keepShow: true,
                    background: "#F5D9AD",
                    opacity: 0.8,
                    hoverStyle: false,
                    specifyBorderRadius: false,
                    minSize: 0,
                    size: "6px",
                    disable: false,
                },
            },
            ops: {
                vuescroll: {
                    detectResize: false,
                },
                scrollPanel: {
                    initialScrollY: 4000,
                },
                bar: {
                    showDelay: 500,
                    onlyShowBarOnScroll: true,
                    keepShow: true,
                    background: "#37474F",
                    opacity: 0.5,
                    hoverStyle: false,
                    specifyBorderRadius: false,
                    minSize: 0,
                    size: "6px",
                    disable: false,
                },
            },
            items: [
                {
                    atendendo: null,
                    mensagens: [{ body: "" }],
                },
            ],
            histConversas: [
            ],
            itemsHist: [
                {
                    mensagens: [{ body: "" }],
                },
            ],
            vsetor: "Gerência",
            txtFileInput: "",
            pastediv: null,
            nomeRules: [
                (value) => !!value || "Informe o nome Completo",
                (value) =>
                    /^$|^.{0,40}$/.test(value) ||
                    "O nome deve ter no máximo 40 caracteres",
            ],
            telefoneRules: [
                (value) =>
                    /^$|^\d+$/.test(value) || "O telefone deve conter somente numeros",
                (value) =>
                    /^$|^.{10,10}$/.test(value) ||
                    "O telefone deve conter no máximo 10 numeros",
            ],
            celularRules: [
                (value) =>
                    /^$|^\d+$/.test(value) || "O celular deve conter somente numeros",
                (value) =>
                    /^$|^.{10,10}$/.test(value) ||
                    "O telefone deve conter 10 numeros. Sem o 9.",
            ],
            emailRules: [
                (value) =>
                    /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                        value
                    ) || "E-mail com formato invalido. Use email@mail.com",
                (value) =>
                    /^$|^.{0,35}$/.test(value) ||
                    "O E-mail deve ter no máximo 35 caracteres",
            ],
            telefonesAc: '',
            dialogEditarContato: false,
            col: "",
            disabledMensagem: false,
            dialogFileUpload: false,
            dialogFinalizarAtendimento: false,
            dialogSetor: false,
            dialogAtendimento: false,
            dialogNovaConversa: false,
            usuario: "",
            notificationAlert: true,
            indiceAtivo: -1,
            indiceAtivoHist: -1,
            mensagem: "",
            mensagemAc: "",
            chatId: "",
            arquivos: "",
            caption: "",
            userDB: "",
            loading: false,
            loadingUpload: false,
            loaderUpload: null,
            loader: null,
            valid: true,
            validAc: true,
            qrCodeDialog: false,
            selecionado: "",
            model: null,
            modelHist: null,
            validUpload: true,
            imgs: "", // Img Url , string or Array of string
            visible: false,
            index: 0,
            indexHist: 0,
            telefones: [],
            setores: [
                "Recursos Humanos",
                "Cobrança",
                "Escrita Fiscal",
                "Contábil",
                "Paralegal",
                "Imposto de Renda",
                "Gerência",
                "Assuntos Gerais",
                "T.I"
            ],
            telefonesAcRules: [
                (v) => !!v || "O contato não pode ser nulo.",
                // (v) => (v && v.length < 11) || "Envie para no maximo de 10 contatos.",
            ],
            msgRules: [(v) => !!v || "A mensagem não pode ser em branco."],
            fileRules: [
                (v) => !!v || "Selecione ao menos um arquivo.",
                (v) => (v && v.length > 0) || "Selecione ao menos um arquivo.",
                (v) => (v && v.length < 6) || "Envie no máximo 5 arquivos por upload.",
                (files) =>
                    !files ||
                    !files.some((file) => file.size > 15000000) ||
                    "O arquivo não pode ser maior que 15mb.",
            ],
        };
    },
    created() {
        this.socket = io("https://www.contabilidadelider.com");
    },
    directives: {
        focus: {
            inserted(el) {
                el.focus();
            },
        },
    },

    methods: {
        atualizarContatos() {
            this.$store.dispatch("wappListaHistorico").then(
                (histConversas) => {
                    if (this.histConversas.length < 1) {
                        this.histConversas = histConversas;
                    }


                },
                (error) => {
                    this.loading = error;
                    this.loading = false;
                }
            );
        },

        telefoneFormat(telefone) {
            if (typeof telefone === "undefined") {
                telefone = "";
            }
            if (telefone.length === 10) {
                return (
                    "(" +
                    telefone.substring(0, 2) +
                    ") " +
                    telefone.substring(2, 6) +
                    "-" +
                    telefone.substring(6)
                );
            } else if (telefone.length === 8) {
                return telefone.substring(0, 4) + "-" + telefone.substring(4);
            } else if (telefone.length === 11) {
                return (
                    "(" +
                    telefone.substring(0, 2) +
                    ") " +
                    telefone.substring(2, 7) +
                    "-" +
                    telefone.substring(7)
                );
            } else if (telefone.length < 4) {
                return "";
            } else return telefone;
        },
        copiarAudio() {
            alert("Audio copiado em sua area de transferência.");
            let testingCodeToCopy = document.querySelector("#audioBody");
            testingCodeToCopy.setAttribute("type", "text");
            testingCodeToCopy.select();
            document.execCommand("copy");
            /* unselect the range */
            testingCodeToCopy.setAttribute("type", "hidden");
            window.getSelection().removeAllRanges();
        },
        paste(e) {
            let dataTransfer = e.clipboardData;
            if (dataTransfer.items[0].getAsFile() !== null)
                this.txtFileInput.push(dataTransfer.items[0].getAsFile());
            // this.txtFileInput.push(dataTransfer.getData("text/plain"));
        },
        background(seen) {
            return seen ? "background-color: white" : "background-color: #FFF3E0";
        },
        append(emoji) {
            this.mensagem += emoji;
        },
        fileExists(url) {
            return new Promise(function (resolve, reject) {
                var img = new Image();
                img.onload = function () {
                    resolve(url);
                };
                img.onerror = function () {
                    reject(url);
                };
                img.src = url;
            });
        },
        async lerQrCode() {
            if (
                await this.fileExists(
                    "https://contabilidadelider.com/intranet/imgs/qrcode.png"
                )
            ) {
                this.qrCodeDialog = true;
            }
        },
        telefoneClicado(col) {
            if (col.atualizado === false) {
                alert(
                    "Este contato ainda não foi atualizado, por favor confirme os dados cadastrais"
                );
                this.col = col;
                this.nome = col.nome;
                this.celular = col.celular;
                this.complementares = col.complementares;
                this.email = col.email;
                this.telefone = col.telefone;
                this.atualizado = col.atualizado;
                typeof col.nome !== "undefined"
                    ? (this.nome = col.nome)
                    : (this.nome = "");
                typeof col.telefone !== "undefined"
                    ? (this.telefone = col.telefone.replace(/\D/g, ""))
                    : (this.telefone = "");
                typeof col.celular !== "undefined"
                    ? (this.celular = col.celular.replace(/\D/g, ""))
                    : (this.celular = "");
                typeof col.email !== "undefined"
                    ? (this.email = col.email)
                    : (this.email = "");
                typeof col.complementares !== "undefined"
                    ? (this.complementares = col.complementares)
                    : (this.complementares = "");
                this.dialogEditarContato = true;
            } else {
                this.telefonesAc = col;
                this.$refs.autocomplete.blur();
            }
        },
        editarContatoBD() {
            this.payload = {
                id: this.col._id,
                nome: this.nome,
                telefone: this.telefone,
                celular: this.celular,
                email: this.email,
                complementares: this.complementares,
            };
            this.$store.dispatch("editarContato", this.payload).then(
                (result) => {
                    this.dataCol = result;
                    this.dialogResposta = true;
                    this.message = "success";
                    this.telefonesAc = this.col;
                },
                (error) => {
                    this.dialogResposta = true;
                    this.loading = false;
                    this.respostaErro = error;
                    this.message = "error";
                }
            );
        },

        clicouLista(index, historico = false) {
            if (!historico) {
                this.indiceAtivo = index;
                if (!this.items[this.indiceAtivo].atendendo) {
                    this.dialogAtendimento = true;
                } else {
                    this.items[this.indiceAtivo].seen = true;
                    //avisar banco que viu a msg;
                    this.payload = {
                        chatId: this.items[this.indiceAtivo].chatId,
                        seen: true,
                    };
                    //this.items[this.indiceAtivo].atendendo = true;

                    this.$store.dispatch("modificarSeen", this.payload).then(
                        () => { },
                        (error) => {
                            this.loading = error;
                            this.loading = false;
                        }
                    );
                }
            } else {
                this.indiceAtivoHist = index;
                this.$store.dispatch("mensagemHistorico", this.payload).then(
                    () => { },
                    (error) => {
                        this.loading = error;
                        this.loading = false;
                    }
                );
            }
            setTimeout(() => {
                this.scrollToElement();
            }, 10);
        },

        showImg(imagem) {
            this.imgs = "";
            this.imgs = imagem;
            this.show();
        },
        show() {
            this.visible = true;
        },
        handleHide() {
            this.visible = false;
        },
        limparCampo() {
            if (this.mensagem == " ") {
                this.mensagem = "";
            }
        },
        async readFile(file) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve, reject) => {
                var fr = new FileReader();
                fr.onload = () => {
                    resolve(fr.result);
                };
                fr.readAsDataURL(file);
            });
        },
        async enviarArquivos() {
            this.loadingUpload = true;
            this.chatId = this.items[this.indiceAtivo].chatId;
            var arquivos = [];
            for (const arquivo of this.txtFileInput) {
                var base64 = await this.readFile(arquivo);
                var nomeArq = arquivo.name;
                arquivos.push({ filename: nomeArq, base64: base64 });
            }

            this.payload = {
                chatId: this.chatId,
                arquivos: arquivos,
                caption: this.caption,
            };

            this.$store.dispatch("enviarArquivos", this.payload).then(
                () => {
                    setTimeout(() => {
                        this.loadingUpload = false;
                        this.dialogFileUpload = false;
                        this.scrollToElement();
                    }, 1000);
                },
                (error) => {
                    this.loading = error;
                    this.loading = false;
                }
            );
        },
        scrollToElement() {
            if (typeof this.$refs["vs"] !== "undefined") {
                this.$refs["vs"].scrollBy(
                    {
                        dy: 10000,
                    },
                    0
                );
            }
        },
        forParaFormat(body, procurarChar, subChar, subChar2) {
            var qtOcorrencia = body.split(procurarChar).length - 1;

            // if (qtOcorrencia % 2 == 0) {
            for (let x = 0; qtOcorrencia >= x; x++) {
                x % 2 == 0
                    ? (body = body.replace(procurarChar, subChar))
                    : (body = body.replace(procurarChar, subChar2));
            }
            //  }
            return body;
        },
        formatarMSG(hist = false) {
            if (!hist) {
                this.items.forEach((item) => {
                    item.mensagens.forEach((mensagem) => {
                        if (
                            ![
                                "pdf",
                                "txt",
                                "doc",
                                "docx",
                                "xls",
                                "xls",
                                "xlsx",
                                "ppt",
                                "pptx",
                                "xml",
                                "gsheet",
                                "bmp",
                                "jpg",
                                "webp",
                                "ofx",
                                "jpeg",
                                "gif",
                                "png",
                                "eps",
                                "raw",
                                "apng",
                                "ico",
                                "svg",
                                "zip",
                                "csv",
                                "7zip",
                                "rar",
                                "rtf",
                                "jfif",
                            ].some((el) =>
                                RegExp(/\.[0-9a-z]{1,5}$|$/)
                                    .exec(mensagem.body)[0]
                                    .includes(el)
                            )
                        ) {
                            mensagem.body = this.forParaFormat(
                                mensagem.body,
                                "*",
                                "<strong>",
                                "</strong>"
                            );
                            mensagem.body = this.forParaFormat(
                                mensagem.body,
                                "```",
                                "<span style='font-family: monospace'>",
                                "</span>"
                            );
                            mensagem.body = this.forParaFormat(
                                mensagem.body,
                                "_",
                                "<i>",
                                "</i>"
                            );

                            mensagem.body = mensagem.body.replace(/\n/g, "<br>");
                        }
                        if (
                            mensagem.quotedMsgBody !== null &&
                            typeof mensagem.quotedMsgBody !== "undefined"
                        ) {
                            mensagem.quotedMsgBody = this.forParaFormat(
                                mensagem.quotedMsgBody,
                                "*",
                                "<strong>",
                                "</strong>"
                            );
                            mensagem.quotedMsgBody = this.forParaFormat(
                                mensagem.quotedMsgBody,
                                "```",
                                "<span style='font-family: monospace'>",
                                "</span>"
                            );
                            mensagem.quotedMsgBody = this.forParaFormat(
                                mensagem.quotedMsgBody,
                                "_",
                                "<i>",
                                "</i>"
                            );

                            mensagem.quotedMsgBody = mensagem.quotedMsgBody.replace(
                                /\n/g,
                                "<br>"
                            );
                        }
                    });
                });
            } else {
                this.itemsHist.forEach((item) => {
                    item.mensagens.forEach((mensagem) => {
                        if (
                            ![
                                "pdf",
                                "txt",
                                "doc",
                                "docx",
                                "xls",
                                "xls",
                                "ofx",
                                "xlsx",
                                "ppt",
                                "pptx",
                                "xml",
                                "gsheet",
                                "bmp",
                                "jpg",
                                "webp",
                                "jpeg",
                                "gif",
                                "png",
                                "eps",
                                "raw",
                                "apng",
                                "ico",
                                "svg",
                                "jfif",
                            ].some((el) =>
                                RegExp(/\.[0-9a-z]{1,5}$|$/)
                                    .exec(mensagem.body)[0]
                                    .includes(el)
                            )
                        ) {
                            mensagem.body = this.forParaFormat(
                                mensagem.body,
                                "*",
                                "<strong>",
                                "</strong>"
                            );
                            mensagem.body = this.forParaFormat(
                                mensagem.body,
                                "```",
                                "<span style='font-family: monospace'>",
                                "</span>"
                            );
                            mensagem.body = this.forParaFormat(
                                mensagem.body,
                                "_",
                                "<i>",
                                "</i>"
                            );
                            mensagem.body = mensagem.body.replace(/\n/g, "<br>");
                        }
                        if (
                            mensagem.quotedMsgBody !== null &&
                            typeof mensagem.quotedMsgBody !== "undefined"
                        ) {
                            mensagem.quotedMsgBody = this.forParaFormat(
                                mensagem.quotedMsgBody,
                                "*",
                                "<strong>",
                                "</strong>"
                            );
                            mensagem.quotedMsgBody = this.forParaFormat(
                                mensagem.quotedMsgBody,
                                "```",
                                "<span style='font-family: monospace'>",
                                "</span>"
                            );
                            mensagem.quotedMsgBody = this.forParaFormat(
                                mensagem.quotedMsgBody,
                                "_",
                                "<i>",
                                "</i>"
                            );

                            mensagem.quotedMsgBody = mensagem.quotedMsgBody.replace(
                                /\n/g,
                                "<br>"
                            );
                        }
                    });
                });
            }
        },
        iniciarAtendimento() {
            this.chatId = this.items[this.indiceAtivo].chatId;
            this.items[this.indiceAtivo].atendendo = true;
            var nomeSep = this.userDB.nome.split(" ");
            var col = nomeSep[0] + " " + nomeSep[1];
            this.payload = {
                chatId: this.chatId,
                col: col,
            };
            this.$store.dispatch("colAtendeu", this.payload).then(
                () => { },
                (error) => {
                    this.loading = error;
                    this.loading = false;
                }
            );
        },
        mudarSetor() {
            var novoSetor = this.vsetor;
            var senderName = this.items[this.indiceAtivo].senderName;
            this.chatId = this.items[this.indiceAtivo].chatId;
            this.payload = {
                chatId: this.chatId,
                setor: novoSetor,
                senderName: senderName,
            };
            this.$store.dispatch("mudarSetor", this.payload).then(
                () => { },
                (error) => {
                    this.loading = error;
                    this.loading = false;
                }
            );
        },
        enviarMsg(numero = null, body = null) {
            this.disabledMensagem = true;
            this.numero = numero
            if (!this.numero) this.numero = this.items[this.indiceAtivo].chatId;
            var nomeSep = this.userDB.nome.split(" ");
            console.log("mensagem => " + this.mensagem);

            if (body) {
                this.mensagemCFunc = body;
            } else {
                this.mensagemCFunc =
                    "*[" +
                    nomeSep[0] +
                    "." +
                    nomeSep[1].charAt(0) +
                    "]* " +
                    this.mensagem;
                console.log(this.mensagemCFunc);
            }
            var dataClient = new Date();
            dataClient = dataClient.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            });
            for (let x = 0; this.items.length > x; x++) {
                if (this.items[x].chatId === this.numero) {
                    this.items[x].mensagens.push({
                        body: this.mensagemCFunc,
                        fromMe: true,
                        horarioBR: dataClient,
                        ack: 1,
                    });
                }
            }
            this.formatarMSG();
            this.scrollToElement();
            setTimeout(() => {
                this.mensagem = " "
                this.disabledMensagem = false;
                this.scrollToElement();
                setTimeout(() => {
                    this.$refs.mensagem.focus();
                }, 40);
            }, 540);
            this.payload = {
                chatId: this.numero,
                body: this.mensagemCFunc,
            };
            this.$store.dispatch("enviarMsg", this.payload).then(
                () => {
                    this.formatarMSG();
                    this.scrollToElement();
                },
                (error) => {
                    console.log(error)
                    this.loading = error;
                    this.loading = false;
                }
            );
        },
        concluirAtendimento() {
            this.chatId = this.items[this.indiceAtivo].chatId;
            var nomeSep = this.userDB.nome.split(" ");
            var col = nomeSep[0] + "." + nomeSep[1].charAt(0);
            this.payload = {
                chatId: this.chatId,
                col: col,
            };
            this.$store.dispatch("concluirAtendimento", this.payload).then(
                () => {
                    this.indiceAtivo = -1;
                },
                (error) => {
                    console.log(error);
                    this.loading = error;
                    this.loading = false;
                }
            );
        },
        popularTelefones() {
            this.$store.dispatch("listarContato").then((telefones) => {
                this.telefones = telefones;
                telefones.forEach((telefone) => {
                    if ((telefone.celular.substring(0, 1) !== "4") && (telefone.celular.substring(0, 1) !== "3") && (telefone.celular.substring(0, 1) !== "6")) {
                        telefone.celular = telefone.celular.substring(0, 2) + "9" + telefone.celular.substring(2)
                    }
                    telefone.chatId = "55" + telefone.celular + "@c.us";
                    telefone.celular = this.telefoneFormat(telefone.celular);
                    telefone.senderName = telefone.nome;
                });
                let contatosEmAberto = [];
                this.$store.dispatch("chatsEmAberto").then(
                    (contatosEmAbertoV) => {
                        if (contatosEmAbertoV.length > 0) {
                            contatosEmAberto = contatosEmAbertoV;
                            for (var i = 0, len = contatosEmAberto.length; i < len; i++) {
                                for (var j = 0, len2 = this.telefones.length; j < len2; j++) {
                                    if (contatosEmAberto[i].chatId === this.telefones[j].chatId) {
                                        this.telefones.splice(j, 1);
                                        len2 = this.telefones.length;
                                    }
                                }
                            }
                            for (i = 0, len = contatosEmAberto.length; i < len; i++) {
                                for (j = 0, len2 = this.telefones.length; j < len2; j++) {
                                    if (contatosEmAberto[i].chatId === this.telefones[j].chatId) {
                                        this.telefones.splice(j, 1);
                                        len2 = this.telefones.length;
                                    }
                                }
                            }
                        }
                    },
                    () => {
                        this.$router.push("/");
                    }
                );
            });
        },
        //vou pegar os telefones do banco de dados da agenda.
        dialogNovaConversaM() {
            this.dialogNovaConversa = true;
            this.notificationAlert = true;
            this.mensagemAc = "";
            this.telefonesAc = '';
            this.popularTelefones();
        },
        iniciarNovaConversa() {
            var setor = this.userDB.setores[1];
            var nomeSep = this.userDB.nome + " L";
            nomeSep = nomeSep.split(" ");
            var mensagemCFunc =
                "*[" +
                nomeSep[0] +
                "." +
                nomeSep[1].charAt(0) +
                "]* " +
                this.mensagemAc;
            this.payload = {
                telefone: this.telefonesAc,
                setor: setor,
                body: mensagemCFunc,
            };

            this.$store.dispatch("iniciarNovaConversa", this.payload).then(
                () => {
                    var telefone = this.payload.telefone;
                    this.items.push({
                        setor: setor,
                        atendendo: true,
                        chatId: telefone.chatId,
                        senderName: telefone.nome,
                        email: "ue",
                        complementares: telefone.complementares,
                        seen: true,
                        avatarImg: "imgs/blank_profile.png",
                        mensagens: [
                            {
                                fromMe: true,
                                body: mensagemCFunc,
                                caption: null,
                                quotedMsgBody: null,
                            },
                        ],
                    });
                    this.msgErro = "";
                    this.dialogError = false;
                    this.indiceAtivo = this.indiceAtivo + 1;
                    this.enviarMsg(telefone.chatId, mensagemCFunc);
                    this.formatarMSG();
                    if (this.items.length > 0) {
                        this.indiceAtivo = this.items.length - 1;
                        if (this.indiceAtivo == 1) {
                            this.indiceAtivo = 0;
                        }
                        // console.log("tamanho do items (>0)-->" + this.items.length);
                    } else {

                        // console.log("Primeira conversa");
                        //   console.log("IndiceAtivo antes -->" + this.indiceAtivo);
                        this.indiceAtivo = 0;
                        //  console.log("IndiceAtivo depois -->" + this.indiceAtivo);
                        //   console.log("tamanho do items -->" + this.items.length);
                    }
                },
                () => {
                    this.msgErro =
                        "Não é possivel iniciar uma nova conversa. <br> O limite de novas conversas a cada <strong> 10 minutos</strong> foi excedido";
                    this.dialogError = true;
                }
            );
        },
    },
    mounted() {
        this.lerQrCode();
        Notification.requestPermission();
        this.$store.dispatch("infoUsuario").then(
            (userDB) => {
                this.$store.dispatch("wappItems", userDB.setores).then((items) => {
                    this.userDB = userDB;
                    if (items.length > 0) {
                        this.items = items;
                        this.userDB = userDB;
                        setTimeout(() => {
                            this.scrollToElement();
                        }, 120);

                        this.formatarMSG();
                    }
                });
            },
            () => {
                this.$router.push("/");
            }
        );
        this.socket.on("webHookou", () => {
            this.$store.dispatch("wappItems", this.userDB.setores).then(
                (items) => {
                    //alert(JSON.stringify(items, null, 2));
                    if (items.length > 0) {
                        this.items = items;
                        this.formatarMSG();
                    } else {
                        this.items = [
                            {
                                atendendo: false,
                                mensagens: [{ body: "" }],
                            },
                        ];
                    }
                },
                () => {
                    this.$router.push("/");
                }
            );
        });
        this.timerId = setTimeout(() => {
            this.itemsHist = [
                {
                    atendendo: false,
                    mensagens: [{ body: "" }],
                },
            ];
        }, 180000);
    },
    watch: {
        model(selecionado) {
            if (typeof selecionado !== "undefined") {
                for (let index = 0; index < this.items.length; index++) {
                    if (this.items[index]._id === selecionado) {
                        this.indiceAtivo = index;
                        this.scrollToElement();
                    }
                }
                if (!this.items[this.indiceAtivo].atendendo) {
                    this.dialogAtendimento = true;
                }
            }
        },
        modelHist(selecionado) {
            if (typeof selecionado !== "undefined") {
                this.$store.dispatch("mensagemHistorico", selecionado).then(
                    (itemsHist) => {
                        if (itemsHist.length > 0) {
                            this.itemsHist = itemsHist;
                            this.formatarMSG();
                            this.indiceAtivoHist = 0
                        } else {
                            this.itemsHist = [
                                {
                                    atendendo: false,
                                    mensagens: [{ body: "" }],
                                },
                            ];
                        }
                    },
                    () => {
                        this.$router.push("/");
                    }
                );
                /*
                for (let index = 0; index < this.itemsHist.length; index++) {
                    if (this.itemsHist[index]._id === selecionado) {
                        this.indiceAtivoHist = index;
                        this.scrollToElement();
                        this.formatarMSG();
                    }
                }*/
            }
        },
        loader() {
            const l = this.loader;
            this[l] = !this[l];

            setTimeout(() => (this[l] = false), 1000);

            this.loader = null;
        },
    },
};
</script>
<style>
.emoji-invoker {
    transition: all 0.2s;
    margin-top: 0.7%;
}

.emoji-invoker:hover {
    transform: scale(1.1);
}

.emojis:after {
    content: "";
    flex: auto;
}

.wrapper {
    width: 100%;
    position: relative;
    display: inline-block;
}

.emoji-invoker {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
}

.emoji-invoker:hover {
    transform: scale(1.1);
}

.emoji-invoker>svg {
    fill: #b1c6d0;
}

.emoji-picker {
    position: absolute;
    z-index: 1;
    border: 1px solid #ccc;
    width: 15rem;
    height: 20rem;
    padding: 1rem;
    box-sizing: border-box;
    border-radius: 0.5rem;
    background: #fff;
    box-shadow: 1px 1px 8px #c7dbe6;
}

.emoji-picker h5 {
    margin-bottom: 0;
    color: #b1b1b1;
    text-transform: uppercase;
    font-size: 0.8rem;
    cursor: default;
}

.emoji-picker .emojis {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.emoji-picker .emojis:after {
    content: "";
    flex: auto;
}

.emoji-picker .emojis span {
    padding: 0.2rem;
    cursor: pointer;
    border-radius: 5px;
}

.emoji-picker .emojis span:hover {
    background: #ececec;
    cursor: pointer;
}
</style>